<template is="header">
  <div aria-label="Encabezado">
    <!-- color="red lighten-5" -->
    <v-toolbar
      v-if="$vuetify.breakpoint.mdAndUp"
      class="my-0"
      height="45"
      tile
      dense
      prominent
      style="flex: none"
      extended
      extension-height="155"
      aria-label="Enlaces a sitios de la rama judicial Colombiana"
    >
      <v-col v-for="(item, index) in options" :key="index" class="pa-0 mx-0">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            :title="item.title"
            transition="slide-x-reverse-transition"
            block
            tile
            depressed
            height="45"
            dark
            class="px-0"
            :color="color[index]"
            :href="item.url"
            target="_blank"
          >
            <span
              :style="
                item.title === 'Corte Suprema de la justicia'
                  ? 'color: black !important'
                  : ''
              "
              :class="`${
                $vuetify.breakpoint.md ? 'body-2' : 'body-1'
              } font-weight-bold text-none px-2`"
              >{{ item.title }}</span
            >

            <v-expand-transition>
              <transition :name="index ? 'slide-fade' : ''">
                <div
                  v-if="hover"
                  class="d-flex white v-card--reveal display-3 grey--text text--darken-3 text-center my-0"
                  style="
                    height: 45px !important;
                    position: absolute;
                    width: 100%;
                    align-items: center;
                    align-content: center;
                    bottom: 0;
                  "
                >
                  <v-row
                    no-gutters
                    align="center"
                    justify="center"
                    class="my-0"
                  >
                    <span
                      :class="`${
                        $vuetify.breakpoint.md ? 'body-2' : 'body-1'
                      } font-weight-bold text-none px-2 pt-5`"
                      >{{ item.title }}</span
                    >
                  </v-row>
                </div>
              </transition>
            </v-expand-transition>
          </v-btn>
        </v-hover>
      </v-col>

      <!--App Bar-->
      <template v-slot:extension>
        <AppBar />
      </template>
    </v-toolbar>

    <!-- Mobile -->
    <v-row v-if="$vuetify.breakpoint.smAndDown">
      <v-col
        cols="12"
        :class="`${
          $vuetify.theme.dark ? 'grey darken-3' : 'blue-grey lighten-5'
        } py-0`"
      >
        <v-row align="center" justify="center" class="px-8 py-0">
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          <div>
            <h5 class="text-center">
              CONSULTA DE PROCESOS
              <br />NACIONAL UNIFICADA
            </h5>
          </div>
          <v-spacer></v-spacer>
          <div>
            <ThemeDark class="ma-0 py-0" />
          </div>
        </v-row>
      </v-col>

      <v-navigation-drawer
        persistent
        v-model="drawer"
        clipped
        fixed
        width="330"
        disable-resize-watcher
      >
        <v-list-item class="my-3">
          <v-list-item-content>
            <v-row>
              <v-row no-gutters align="center" justify="center">
                <img
                  alt="Ir a la rama Judicial"
                  cover
                  src="@/assets/logo1.png"
                  width="30"
                />
              </v-row>
              <div>
                <v-list-item-title
                  class="body-2 text-center font-weight-bold leading--text mt-2"
                  style="line-height: 0.4cm"
                >
                  CONSULTA DE PROCESOS
                  <br />NACIONAL UNIFICADA
                </v-list-item-title>
              </div>

              <v-row no-gutters align="center" justify="center">
                <img
                  alt="Ir a la presidencia de la República de Colombia"
                  cover
                  src="@/assets/EscudoColombia.png"
                  width="35"
                />
              </v-row>
            </v-row>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-col cols="12" class="pt-2 pb-0">
          <v-row no-gutters align="center" justify="end">
            <v-col class="px-0">
              <v-row no-gutters align="center" justify="end">
                <v-btn
                  icon
                  href="https://consultaprocesos.ramajudicial.gov.co/Documentacion/Ayuda.html"
                  target="_blank"
                  title="Ir a la Ayuda"
                  aria-label="Ir a la Ayuda"
                >
                  <v-icon>fas fa-question-circle</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col class="mt-4 px-5">
          <template v-for="(item, index) in options">
            <v-btn
              :key="index"
              block
              tile
              depressed
              height="45"
              dark
              :to="item.url"
              class="px-0 my-2"
              :color="color[index]"
              :href="item.url"
              target="_blank"
              :title="item.title"
            >
              <span class="font-weight-bold text-none body-2">{{
                item.title
              }}</span>
            </v-btn>
          </template>
        </v-col>
        <v-divider></v-divider>
        <v-footer absolute class="mb-0">
          <v-row align="center" justify="center" class="py-8 mb-5">
            <v-btn
              color="leading"
              width="150"
              dark
              class
              @click="drawer = !drawer"
              >Volver</v-btn
            >
          </v-row>
        </v-footer>
      </v-navigation-drawer>
    </v-row>
  </div>
</template>

<script>
import AppBar from "@/components/header/AppBar";
import ThemeDark from "@/components/ThemeDark";
export default {
  components: { AppBar, ThemeDark },
  data: () => ({
    drawer: false,
    color: ["#91be91", "#ffd20f", "#4f90c8", "#cb302f", "#0a7a39"],
    options: [
      {
        title: "Consejo Superior de la Judicatura",
        url:
          "https://www.ramajudicial.gov.co/web/consejo-superior-de-la-judicatura/portal/inicio",
      },
      {
        title: "Corte Suprema de justicia",
        url: "http://www.cortesuprema.gov.co/corte/",
      },
      { title: "Consejo de Estado", url: "http://www.consejodeestado.gov.co/" },
      {
        title: "Corte Constitucional",
        url: "https://www.corteconstitucional.gov.co/",
      },
      {
        title: "Comisión Nacional de Disciplina Judicial",
        url:
          "https://www.ramajudicial.gov.co/web/comision-nacional-de-disciplina-judicial",
      },
    ],
    right: null,
  }),
};
</script>
<style scoped>
::v-deep .v-toolbar__content,
.v-toolbar__extension {
  padding: 0px !important;
  margin: 0px !important;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-to {
  transform: translateX(100%);
}
</style>